import * as React from 'react';
import { Modal } from '@roo/roo';
import utils from '@/utils/utils';
import { delService, IModalProps } from '../api';

const { useState } = React;

const Index = (props: IModalProps) => {
    const { service, handleClose, refresh, visible } = props;
    const [loading, setLoading] = useState<boolean>(false);

    const handleConfirm = () => {
        if (!service) return;
        setLoading(true);
        const { serviceAuditID, serviceID } = service;
        const params = { serviceID, serviceAuditID };
        delService(params)
            .then(() => {
                utils.toast('success', '操作成功');
                handleClose();
                refresh();
            })
            .catch(() => {})
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Modal
            title="删除服务"
            visible={visible}
            onCancel={() => {
                handleClose();
            }}
            confirmButtonProps={{ loading }}
            onConfirm={handleConfirm}
        >
            <p>删除后无法恢复，确定要删除吗？</p>
        </Modal>
    );
};

export default Index;
